import {
  Component,
  forwardRef,
  Inject,
  Input
}                             from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { InvoiceModel }       from '../invoices/models/invoice';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }   from '@ngx-translate/core';

import { MessagesService }                   from '../messages/messages.service';
import { StripePaymentErrorCallbackModel }   from './models/stripe.payment.error-callback';
import { StripePaymentSuccessCallbackModel } from './models/stripe.payment.success-callback';
import { StripeService }                     from './stripe.service';

@Component({
  selector   : 'wor-stripe-checkout',
  template: require('./stripe.checkout.component.html')
})
export class StripeCheckoutComponent {
  public accountId : string = this.stripeService.getAccountId();
  public publicKey : string = this.stripeService.getPublicKey();

  @BlockUI('stripeCheckoutBlock') block : NgBlockUI;

  @Input() invoice : InvoiceModel;

  constructor (
    public  activeModal     : NgbActiveModal,
    private messagesService : MessagesService,
    @Inject(forwardRef(() => StripeService))
    private stripeService   : StripeService,
    private translateService: TranslateService
  ) {}

  /**
   * WS-7263: StripePaymentComponent emits { error } and { intent }, not the bare error or intent.
   * These handlers were typed and written as though they received the bare object, so
   * handlePaymentError read message off the wrapper, found undefined, and raised a notification
   * with an empty body. A declined card therefore showed nothing at all and the workshop
   * reasonably concluded the customer had paid.
   *
   * handlePaymentSuccess had the same mismatch but survived it, because it shows a fixed
   * translated message rather than anything off its argument. It did pass the wrapper to
   * activeModal.close, which contradicts checkout's declared Promise<PaymentIntent>. Both callers
   * of StripeService.checkout ignore the resolved value, so correcting it changes nothing today
   * and stops the next caller being handed the wrong shape.
   */
  handlePaymentError ( { error } : StripePaymentErrorCallbackModel ) : void {
    this.block.stop();

    this.messagesService.error(error.message);
  }

  handlePaymentSuccess ( { intent } : StripePaymentSuccessCallbackModel ) : void {
    this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PAYMENT_SUCCESSFUL'), 'success');

    this.activeModal.close(intent);
  }

  submit () : void {
    this.block.start(this.translateService.instant('GENERAL_SPACE.MESSAGE.SENDING'));

    window['collectStripePayment']();
  }
}
